export default "__VITE_ASSET__CUpO7CqC__"